import { FormControl } from "@angular/forms";
import { environment } from "src/environments/environment";
import { marked } from 'marked';

export const emailPattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,6}$/;

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	let errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	return errObj ? errObj : null;
}

export const flagList = [
	{ id: '5', name: "Hospitalised", class: "fa fa-square mr-sm text-primary" },
	{ id: '1', name: "New case", class: "fa fa-flag mr-sm text-black" },
	{ id: '4', name: "Physio-cases", class: "fa fa-flag mr-sm text-danger" },
	{ id: '2', name: "Follow-up", class: "fa fa-flag mr-sm text-warning" },
	{ id: '3', name: "Closed", class: "fa fa-flag mr-sm text-success" }
];

export function isSpecialSuperAdmin() {
	return localStorage.getItem("cube_superadmin") == "true";
	/* const logged_in_user = localStorage.getItem("emailId");
	const cube_users = JSON.parse(localStorage.getItem("cube_users")!) || [];
	const len = cube_users.length;
	for (let i = 0; i < len; i++) {
		if (logged_in_user == cube_users[i]) {
			return true;
		}
	}
	return false; */
}

function generateUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function getDeviceId(): string {
	const key = 'random_device_id';
	let deviceId: string = localStorage.getItem(key) || "";
	if (!deviceId) {
		deviceId = generateUUID();
		console.log(deviceId)
		localStorage.setItem(key, deviceId);
	}
	return deviceId;
}

export const lab_report_categories = [
	{ id: 2, category: "Lab Reports" },
	{ id: 10, category: "Lab Reports NABL" },
	{ id: 11, category: "Lab Reports NON NABL" }
]

export const Cube_Clinics = ["3Cube Medicare"];

export function cleanHtmlString(content: string) {
	if (!content) return '';
	content = content.replace(/^(\d+)\./gm, '$1\\.');
	const match = content.match(/```(?:html)?\s*([\s\S]*?)\s*```/i);
	content = match ? match[1].trim() : content;
	const html = marked.parse(content) as string;
	const line_height = "line-height:1.2;";
	const cleanedHtml = html
		.replace(/<p>/g, '')
		.replace(/<\/p>/g, '');
	const styledHtml = cleanedHtml.replace(/<([a-z][a-z0-9]*)\b([^>]*)>/gi, (match, tag, attrs) => {
		let extraStyles = 'margin:0 !important;padding:0 !important;' + line_height;
		if (tag === 'ul' || tag === 'ol') {
			extraStyles += 'padding-left:16px !important;';
		}
		if (tag === 'li') {
			extraStyles += 'margin-bottom:2px !important;';
		}
		if (/^h[1-6]$/.test(tag) && !/margin-top/i.test(attrs)) {
			extraStyles += 'margin-top:10px !important;';
		}
		if (/style\s*=/.test(attrs)) {
			return `<${tag}${attrs.replace(/style\s*=\s*["']([^"']*)["']/i,
				(m: any, styles: any) => `style="${styles};${extraStyles}"`)}>`;
		}
		return `<${tag}${attrs} style="${extraStyles}">`;
	});
	return styledHtml;
}

export function isArray(val: any): boolean {
	return Array.isArray(val);
}

export function isObject(val: any): boolean {
	return val && typeof val === 'object' && !Array.isArray(val);
}

export function formatKey(key: string): string {
	return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function getLabelClass(key: string): string {
	key = key.toLowerCase();
	if (key.includes('status')) {
		return 'label text-success';
	}
	if (key.includes('concerning')) {
		return 'label text-danger';
	}
	if (key.includes('prediction')) {
		return 'label text-info';
	}
	return 'label text-default';
}

export function getIcon(key: string): string {
	key = key.toLowerCase();
	if (key.includes('concerning')) {
		return 'fa fa-exclamation-triangle text-danger mr-sm';
	}
	if (key.includes('recommended')) {
		return 'fa fa-check-square-o text-info mr-sm';
	}
	if (key.includes('prediction')) {
		return 'fa fa-clock-o text-primary mr-sm';
	}
	return '';
}

export function trackByIndex(index: number) {
	return index;
}

export function trackByKey(index: number, key: string) {
	return key;
}

export function removeFromArray(array: any[], index: number) {
	array.splice(index, 1);
}

export function addInArray(array: any[]) {
	array.push("");
}

export const show_report_message_to = [
	"teekay shipping (india) pvt. ltd."
]

export function g_s_t_number_validation(control: FormControl) {
	let gstin: any = control.value;
	if (gstin == null || gstin === "") {
		/* return { 'gstn_required': true }; */
		return null;
	}
	gstin = gstin.toUpperCase();
	var isAlphaNumeric = /^[a-z0-9]+$/i.test(gstin);
	if (!isAlphaNumeric) {
		return { 'gstn_alphanumeric': true };
	}
	//Chech if 15 characters
	if (gstin.length != 15) {
		return { 'gstn_length': true };
	}
	//Check state code i.e. first 2 digits number from 1 to 37 or 98
	var stateCode = parseInt(gstin.substring(0, 2));
	var isStateCorrect = false;
	switch (true) {
		case (stateCode < 1):
			isStateCorrect = false;
			break;
		case (stateCode < 38):
			isStateCorrect = true;
			break;
		case (stateCode == 98):
			isStateCorrect = true;
			break;
		default:
			isStateCorrect = false;
			break;
	}
	if (!isStateCorrect) {
		return { 'gstn_statecode': true };
	}
	//Pan Letters check 3rd to 7th and 12th are alphabets
	var panLetters = gstin.substring(2, 7) + gstin.substring(11, 12);
	var letterCheck = /^[a-z]+$/i.test(panLetters);
	if (!letterCheck) {
		return { 'gstn_pan': true };
	}
	//PAN numbers check 8th to 11th are numbers
	var panDigits = gstin.substring(7, 11);
	var digitCheck = /^\d+$/.test(panDigits);
	if (!digitCheck) {
		return { 'gstn_pan': true };
	}
	//Second last character should be "Z"
	var defaultChar = gstin.substring(13, 14);
	if (defaultChar != "Z" && defaultChar != "z") {
		return { 'gstn_secondlast': true };
	}
	//last character Checksum
	var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	var lastChar = gstin.substring(14, 15);
	var first14Chars = gstin.substring(0, 14);
	var res = 0;
	for (var i = 0; i < first14Chars.length; i++) {
		var char = first14Chars.charAt(i);
		var placeValue = str.indexOf(char);
		var factor;
		if ((i + 1) % 2 == 0) {
			factor = 2;
		} else {
			factor = 1;
		}
		var multiplication = placeValue * factor;
		var quotient = Math.floor(multiplication / 36);
		var remainder = multiplication % 36;
		res += quotient + remainder;
	}
	var res1 = res % 36;
	var res2 = (36 - res1) % 36;
	var checksumChar = str.charAt(res2);
	if (checksumChar != lastChar) {
		return { 'gstn_checksum': true };
	}
	return null;
}

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

export function isPdf(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "pdf";
	} catch (error) {
		return false;
	}
}

export function getStringSizeInBytes(value: string): number {
	return new Blob([value]).size;
}

export const maxMailSizeMB = 25;

export const maxsingleFileSizeMB = 20;

export const disclaimer = '<h5><span style=\"color: #666666;\">Disclaimer: </span><em style=\"color: #666666;\">\"This email and any attachments are confidential and intended solely for the use of the recipient. Any unauthorized review, use, disclosure, or distribution is prohibited.\"</em></h5>';

export const MAIL_SIGNATURE = '';

export const splitPattern = new RegExp('[,;\t\r\n]+');